<template lang="pug">
  component(v-bind:is="layout")
</template>

<script>
import { mapGetters } from 'vuex'
import * as commonLayouts from '@/common/layouts/index.js'
import * as appLayouts from '@/app/layouts/index.js'

let layouts = {}

for (let k of Object.keys(commonLayouts)) {
  const layout = commonLayouts[k]
  layouts[layout.name] = layout
}

for (let k of Object.keys(appLayouts)) {
  const layout = appLayouts[k]
  layouts[layout.name] = layout
}

export default {
  name: 'app',
  components: layouts,
  data () {
    return {}
  },
  computed: {
    ...mapGetters('common/layout', ['layout'])
  }
}
</script>

<style lang="stylus">
@import '../../node_modules/material-design-icons-iconfont/dist/material-design-icons.css';
@import '../../node_modules/font-awesome/css/font-awesome.min.css';
@import '../../node_modules/vuetify/dist/vuetify.min.css';
@import './styles';
@import './../app/styles';
</style>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/common/App.vue